import { Polyline } from 'react-leaflet';
import type { IServiceJourneyDetails } from '../../../../../../../../../models/service-journey-details.model';

function ServiceJourneyPolylines({ serviceJourney, disabled }: { serviceJourney: IServiceJourneyDetails; disabled: boolean }) {
  const { serviceJourneyCoordinates } = serviceJourney;
  if (!serviceJourneyCoordinates || serviceJourneyCoordinates.length === 0) {
    return null;
  }

  const latlngsOnTripLeg: L.LatLngExpression[] = [];
  const latLngsBeforeTripLeg: L.LatLngExpression[] = [];
  const latLngsAfterTripLeg: L.LatLngExpression[] = [];
  const lowerOpacity = 0.35;
  const onTripLegOpacity = !disabled ? 1 : lowerOpacity;
  const onTripLegPathOptions1 = { weight: 16, color: serviceJourney.line.foregroundColor, opacity: onTripLegOpacity };
  const onTripLegPathOptions2 = { weight: 10, color: serviceJourney.line.backgroundColor, opacity: onTripLegOpacity };

  for (let i = 0; i < serviceJourneyCoordinates.length; i += 1) {
    if (serviceJourneyCoordinates[i].isOnTripLeg) {
      latlngsOnTripLeg.push([serviceJourneyCoordinates[i].latitude, serviceJourneyCoordinates[i].longitude]);
    } else if (latlngsOnTripLeg.length === 0) latLngsBeforeTripLeg.push([serviceJourneyCoordinates[i].latitude, serviceJourneyCoordinates[i].longitude]);
    else latLngsAfterTripLeg.push([serviceJourneyCoordinates[i].latitude, serviceJourneyCoordinates[i].longitude]);
  }

  latLngsBeforeTripLeg.push(latlngsOnTripLeg[0]);
  latLngsAfterTripLeg.unshift(latlngsOnTripLeg[latlngsOnTripLeg.length - 1]);

  return (
    <>
      <Polyline positions={latLngsBeforeTripLeg} weight={16} color={serviceJourney.line.foregroundColor} opacity={lowerOpacity} />
      <Polyline positions={latLngsBeforeTripLeg} weight={10} color={serviceJourney.line.backgroundColor} opacity={lowerOpacity} />
      <Polyline positions={latlngsOnTripLeg} pathOptions={onTripLegPathOptions1} />
      <Polyline positions={latlngsOnTripLeg} pathOptions={onTripLegPathOptions2} />
      <Polyline positions={latLngsAfterTripLeg} weight={16} color={serviceJourney.line.foregroundColor} opacity={lowerOpacity} />
      <Polyline positions={latLngsAfterTripLeg} weight={10} color={serviceJourney.line.backgroundColor} opacity={lowerOpacity} />
    </>
  );
}

export default ServiceJourneyPolylines;
